import Vue from 'vue';
import VueRx from 'vue-rx';
import '@/plugins';
import App from './App.vue';
import router from './router';
import { store, i18n } from './index';

Vue.config.productionTip = false;
Vue.use(VueRx);

new Vue({
  render: (h) => h(App),
  router,
  store,
  i18n
}).$mount('#app');
